import { render } from "./BookingHelp.vue?vue&type=template&id=b0b0815c&scoped=true"
import script from "./BookingHelp.vue?vue&type=script&lang=js"
export * from "./BookingHelp.vue?vue&type=script&lang=js"

import "./BookingHelp.vue?vue&type=style&index=0&id=b0b0815c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b0815c"]])

export default __exports__